import React from 'react';
import styled from 'react-emotion';
import log from 'util/log';

const Panel = styled('article')({
  label: 'panel',
  backgroundRepeat: 'repeat',
  marginTop: '10px',
  borderRadius: '10px',
  overflow: 'hidden',
  width: '100%',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  flexDirection: 'column',
  '& section': {
    paddingLeft: '2px',
  },

  '& hr': {
    marginBottom: '1em',
    clear: 'both',
    width: 0,
    height: 0,
    background: 'transparent',
    border: 'none',
  },

  '& p': {
    marginTop: 0,
    marginBottom: '1.5em',
  },
}, (props) => {
    log.info('props ', props);
    const { theme } = props;
    return ({
        color: theme.panel.textColor,
        backgroundImage: `url(${theme.panel.backgroundImage})`,
        backgroundColor: theme.panel.backgroundColor,
        '& h3': {
          ...theme.typography.heading,
          marginBottom: '0.1em',
          marginTop: 0,
        },
    });
});

const Title = styled('h2')({
  fontSize: '1.2em',
  textAlign: 'center',
  fontWeight: 'normal',
  marginTop: 0,
  marginBottom: '0.2em',
  top: 0,
  padding: 0,
  height: '1.2em',
  width: '100%',
  flexGrow: 0,
  flexShrink: 0,
}, ({ theme }) => ({
  backgroundColor: theme.panel.title.backgroundColor,
  color: theme.panel.title.textColor,
  fontSize: theme.panel.title.fontSize,
  fontWeight: theme.panel.title.fontWeight,
}));

const Body = styled('div')({
  padding: '0 10px 10px 10px',
  bottom: 0,
  marginBottom: '10px',
  marginRight: '10px',
  overflow: 'auto',
});

export default ({title, children, className}) => (
  <Panel className={className}>
    <Title>{title}</Title>
    <Body>
    {children}
    </Body>
  </Panel>);



// WEBPACK FOOTER //
// ./src/components/panel/panel.js